<!--
   Created by qing on 2020/2/19 2:17 下午
   Des:
-->
<template>

  <div v-if="filterWay" class="filter-content">
    <van-field v-model.number="filter.value[0]" type="number" placeholder="请输入筛选值"/>
  </div>

  <div v-else>
    <div class="filter-yes-no">
      <span v-if="field.closeText">{{field.closeText}}</span>
      <span>
            <van-switch
              size="20"
              v-model="current[0]"
              :disabled="disabled"
              @change="filterChange"
              :active-value="1"
              :inactive-value="0"
              :active-color="current.openColor"
              :inactive-color="current.closeColor">
            </van-switch>
           </span>
      <span v-if="field.openText">{{field.openText}}</span>
    </div>
  </div>

</template>

<script>
  import current from "./mixin"
  export default {
    mixins: [current],
    data() {
      return {};
    },

    computed: {
      checked: {
        get () {
          return Boolean(this.current[0])
        },
        set (bol) {
          this.current[0] = Number(bol)
        }
      }
    }
  };
</script>

<style lang="less">

  .filter-yes-no {
    display: flex;
    align-items: center;

    span {
      margin-right: 5px;
    }
  }
</style>
